<template>
  <div class="dynamic-fields">
    <div class="path-wrapper">
      <div class="left">
        {{ atSelectTypePath }}
      </div>
      <div class="right">
        {{ atSelectType ? $t('filter.'+ atSelectType.key + '.label') : '' }}
      </div>
    </div>
    <template v-if="atSelectType && renderDynamicField">
      <template v-if="atSelectType.type === 'list'">
        <template v-for="atItem in attributeValues">
          <div
            :key="atItem.id"
            :class="{make: atItem === getFieldValue(atSelectType)}"
            class="subcategory"
            @click="setSelectFieldValue(atItem, atSelectType)"
          >
            <i
              class="subcategory-icon"
              :class="['icon-'+atItem.key]"
            />
            <span>{{ atItem.name }}</span>
            <div
              :class="{ hide: atItem === getFieldValue(atSelectType) }"
              class="arrow"
            >
              <i class="icon-arrow-r" />
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <el-row class="range-slider mobile-category-input-number">
          <div class="block">
            <el-input-number
              v-if="atSelectType.type === 'range'"
              v-model="inputNumberCache[atSelectType.id]"
              :min="Number(atSelectType.type_data_parsed.min)"
              :max="Number(atSelectType.type_data_parsed.max)"
            />
            <el-button
              type="primary"
              @click="setSelectFieldValue(inputNumberCache[atSelectType.id], atSelectType)"
            >
              {{ $t('category.confirm.text') }}
            </el-button>
          </div>
        </el-row>
      </template>
    </template>
  </div>
</template>

<script>
import dynamicFields from '@/mixins/filters/dynamic-fields';
import isEqual from 'lodash-es/isEqual';
import isArray from 'lodash-es/isArray';
import mobileDynamicFields from '@/mixins/filters/mobile-dynamic-fields';
import { getFillableAttributeTypes } from '@/store/filters/filters.getters';

export default {
  mixins: [
    dynamicFields,
    mobileDynamicFields,
  ],
  props: {
    category: {
      type: Object,
      default: () => ({})
    },
    subcategory: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      allowAllFieldTypes: true,
      inputNumberCache: [],
    };
  },
  computed: {
    attributeValues() {
      if (this.atSelectType && this.atSelectType.type_data_parsed) {
        if (this.atSelectType.parent_key) {
          const atParentType = this.attributeTypes
            .find(item => item.key === this.atSelectType.parent_key);
          let atParentValue = this.getFieldValue(atParentType);
          atParentValue = atParentValue && atParentValue.value ?
            atParentValue.value : atParentValue;
          if (atParentType && atParentValue) {
            return this.atSelectType.type_data_parsed
              .filter(item => item.parent === atParentValue);
          }
        }
        return this.atSelectType.type_data_parsed;
      }
      return null;
    },
    attributeTypes() {
      const category = this.category;
      const subcategory = this.subcategory;
      return getFillableAttributeTypes({ category, subcategory });
    },
  },
  created() {
    this.value.forEach((item) => { this.inputNumberCache[item.attribute_type_id] = item.value; });
  },
  methods: {
    getFieldValue(atType) {
      if (atType) {
        const selectedValue = isArray(this.value) ?
          this.value.find(item => item.attribute_type_id === atType.id) : null;
        return selectedValue && isArray(atType.type_data_parsed) ?
          atType.type_data_parsed
            .find(item => (item.value || item) === selectedValue.value)
          : selectedValue;
      }
      return null;
    },
    _setFieldValue(value, type) {
      if (!isEqual(value, this.getFieldValue(type))) {
        const newAttributes = [...this.value];
        const changedAttribute = newAttributes.find(item => item.attribute_type_id === type.id);
        const changedAttributeValue = value && value.value ? value.value : value;

        if (!changedAttribute) {
          newAttributes.push({
            attribute_type_id: type.id,
            value: changedAttributeValue,
          });
        } else {
          changedAttribute.value = changedAttributeValue;
        }
        this.$emit('input', newAttributes);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CategoryPopup/MobileCategoryFields.vue